import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import './index.css'
import { router } from './router/routes'

import initSentry from './sentry.config'
initSentry();
createRoot(document.getElementById('root')!).render(
  <RouterProvider router={router()} />
)
